// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NewProgressBar_wrapper_2g2BT","progress":"NewProgressBar_progress_1PYMv","progress__state":"NewProgressBar_progress__state_1Onm4"};